<script setup>
import { useI18n } from '../../i18n.js'
import { runKind } from '../../monitoring.js'
import { runKinds } from '../../monitoring/journalState.js'
import JournalPeriodFields from './JournalPeriodFields.vue'
import JournalOutcomeFields from './JournalOutcomeFields.vue'
import JournalOptionSelect from './JournalOptionSelect.vue'
defineProps({ model: Object, sources: Array, options: Object, invalid: Boolean })
const emit = defineEmits(['options'])
const { t } = useI18n()
</script>
<template>
  <JournalPeriodFields :model="model" journal="runs" :invalid="invalid" />
  <div class="journal-filter-fields">
    <JournalOutcomeFields :model="model" />
    <label>{{ t('journalWorkplace') }}<select v-model="model.sourceInstanceId" :aria-label="t('journalWorkplace')"><option value="">{{ t('journalAllWorkplaces') }}</option><option v-for="source in sources" :key="source.id" :value="String(source.id)">{{ source.displayName }}</option></select></label>
    <JournalOptionSelect v-model="model.templateId" :label="t('template')" :all-label="t('journalAllTemplates')" :state="options.template" @load="(page, q) => emit('options', 'template', page, q)" />
    <JournalOptionSelect v-model="model.actor" :label="t('auditActor')" :all-label="t('allUsers')" :state="options.actor" @load="(page, q) => emit('options', 'actor', page, q)" />
    <label>{{ t('journalFormat') }}<select v-model="model.kind" :aria-label="t('journalFormat')"><option value="">{{ t('journalAllFormats') }}</option><option v-for="value in runKinds" :key="value" :value="value">{{ runKind(t, value) }}</option></select></label>
  </div>
</template>
